export const NBSP = '\u00A0';
export const DEFAULT_QUANTITY = 'units';
export const DEFAULT_PLK = 'plk';

export const DISABLED_CHART_MESSAGE = "The huge amount of data points can't be properly visualized in a chart.";
export const MAX_LEGEND_LENGTH = 23;
export const MAX_DOUBLE_LINE_LEGEND_LENGTH = 13;

export const SHARED_BRAND_ASTERIX = ' *';
export const SHARED_BRAND_TOTAL = ' (total)';

export const MAX_COLUMNS_PER_SLIDE = 15;
